export default "__VITE_ASSET__Ci9C3j6L__"